// extracted by mini-css-extract-plugin
export var content = "_b5-3";
export var list = "_b5-4";
export var settingsContent = "_b5-7";
export var settingsPanel = "_b5-8";
export var state = "_b5-6";
export var triggerBadge = "_b5-2";
export var triggerButton = "_b5-1";
export var triggerShell = "_b5-0";
export var unreadDot = "_b5-5";